import styled from 'styled-components';
export const Title = styled.dt `
  position: relative;
`;
export const Container = styled.dl `
  @apply m-0;
  color: var(--text-color-0);

  dt[data-role='description-title'] {
    @apply font-bold m-0 text-base;
  }

  dd[data-role='description-content'] {
    @apply text-sm m-0;
  }
`;
